<!-- Uses your exact structure & classes; just adds a few a11y/mobile niceties -->
<div class="phone-input-wrapper" [class.light]="isLight">
  <div class="prefix">{{ dialCode }}</div>

  <input
    #phoneInput
    type="tel"
    name="tel"
    class="number-input phone-input expanded mb16"
    placeholder="XXX XXX XXXX"
    inputmode="tel"
    autocomplete="tel-national"
    appPhoneFormat
    [disabled]="disabled"
    [(ngModel)]="phoneNumber"
    (input)="onPhoneNumberEntry($event.target?.value || '')"
    (ngModelChange)="onPhoneModelChange($event)"
    (paste)="onPhonePaste($event)"
    (blur)="onBlur()"
    [attr.aria-invalid]="(required && !phoneNumber) ? 'true' : null"
    [attr.aria-describedby]="descId"
  />
</div>

<!-- Optional assistive text slot (style this in your SCSS if you use it) -->
<!-- <div [id]="descId" class="assistive" style="display:none;"></div> -->
